export const STAKEHOLDER_CONTACT_ACTIONS = [
  { value: "no_answer", label: "No answer" },
  { value: "left_voicemail", label: "Left voicemail" },
  { value: "spoke", label: "Spoke" },
  { value: "texted", label: "Texted" },
  { value: "emailed", label: "Emailed" },
];

export const STAKEHOLDER_CONTACT_ACTION_LABELS = STAKEHOLDER_CONTACT_ACTIONS.reduce(
  (acc, action) => ({
    ...acc,
    [action.value]: action.label,
  }),
  {}
);

export const STAKEHOLDER_FOLLOW_UP_TYPES = [
  { value: "call", label: "Call" },
  { value: "text", label: "Text" },
  { value: "email", label: "Email" },
  { value: "check_in", label: "Check-in" },
  { value: "encourage", label: "Encourage" },
];

export const STAKEHOLDER_FOLLOW_UP_TYPE_LABELS = STAKEHOLDER_FOLLOW_UP_TYPES.reduce(
  (acc, action) => ({
    ...acc,
    [action.value]: action.label,
  }),
  {}
);

export const STAKEHOLDER_URGENCY_OVERRIDE_OPTIONS = [
  { value: "auto", label: "Automatic" },
  { value: "direct", label: "Direct Kevin follow-up" },
  { value: "not_direct", label: "Not direct Kevin follow-up" },
];
